var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"loading-box"},[_c('a-card',{staticClass:"loading-card",staticStyle:{"width":"300px"},attrs:{"bordered":false}},[_c('a-spin',{attrs:{"tip":_vm.text,"size":"large"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }